import { render, staticRenderFns } from "./MessageHeader.vue?vue&type=template&id=247ea0fd&scoped=true&"
import script from "./MessageHeader.vue?vue&type=script&setup=true&lang=js&"
export * from "./MessageHeader.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MessageHeader.vue?vue&type=style&index=0&id=247ea0fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247ea0fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('247ea0fd')) {
      api.createRecord('247ea0fd', component.options)
    } else {
      api.reload('247ea0fd', component.options)
    }
    module.hot.accept("./MessageHeader.vue?vue&type=template&id=247ea0fd&scoped=true&", function () {
      api.rerender('247ea0fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/order/components/orderDetail/MessageHeader.vue"
export default component.exports